import React from 'react';

interface IProps {
  style?: any;
}

const FavoriteDesignIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="15" height="13" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.45824 5.37082e-05C4.05587 5.37082e-05 2.66101 0.554276 1.59797 1.6668C-0.528168 3.8918 -0.534276 7.46294 1.5894 9.68963L10.0958 18.6106C10.3018 18.8283 10.6931 18.8283 10.899 18.6106C13.7366 15.6409 16.5678 12.6679 19.4054 9.69825C21.5315 7.47322 21.5315 3.90047 19.4054 1.67543C17.2793 -0.549595 13.8023 -0.549645 11.6762 1.67543L10.5017 2.89311L9.32724 1.6668C8.18102 0.462655 6.76082 -0.00577731 5.45824 5.37082e-05Z" fill={props.style?.fillColor ? props.style.fillColor : "#ffffff"}/>
    </svg>
  )
}

export default FavoriteDesignIcon;